import { RouterReducerState, createRouterSelector, getRouterSelectors } from '@ngrx/router-store';
import { Selector } from '@ngrx/store';

export { ROUTER_NAVIGATED, RouterNavigatedAction } from '@ngrx/router-store';

// routerSelector can return null, which is not reflected in the type
const routerSelector: Selector<any, RouterReducerState | null> = createRouterSelector();
export { routerSelector };

export const { selectCurrentRoute, selectRouteParam, selectRouteData } = getRouterSelectors();
